import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Divider } from "antd5"; // button should probably be textbutton

import { SelectBuyerList } from "components/form_components/BuyerListSelect";
import { BuyerSelect } from "components/form_components/BuyerSelect";
import { BuyerTypeSelect } from "components/form_components/BuyerTypeSelect";
import { DateRange } from "components/form_components/Inputs";
import { SupplierSelect } from "components/form_components/SupplierSelect";
import { useFormAutoSubmit } from "../../lib/hooks/useFormAutoSubmit";
import FilterFormTitle from "../filter_form/filter_form_title/FilterFormTitle";
import { SpendDataFilters as Filters } from "./hooks/useSpendPageState";

import css from "./SpendDataFilters.module.scss";

function SpendDataFilters({
  onClose,
  setFilters: handleChange,
  filters,
}: {
  onClose: () => void;
  filters: Filters;
  setFilters: (newFilters: Filters) => void;
}) {
  const { control, watch, getValues, trigger, setValue } = useForm<Filters>({
    defaultValues: filters,
    mode: "onChange",
  });

  const data = watch();

  useFormAutoSubmit({
    watch,
    getValues,
    trigger,
    onChange: handleChange,
  });

  // Update form values when filters prop changes in parent
  useEffect(() => {
    Object.keys(filters).forEach((key) => {
      setValue(key as keyof Filters, filters[key as keyof Filters]);
    });
  }, [filters, setValue]);

  return (
    <form aria-label="Spend filters">
      <FilterFormTitle onClose={onClose} />
      <div className={css.formContent}>
        <div className={css.filterGroup}>
          <h3>Transaction details</h3>
          <div className={css.filterInput}>
            <DateRange name="dateRange" control={control} label="Transaction date" />
          </div>
        </div>

        <Divider />

        <div className={css.filterGroup}>
          <h3>Buyer</h3>
          <div className={css.filterInput}>
            <BuyerSelect
              name="buyers"
              label="Buyers"
              control={control}
              mode="multiple"
              placeholder="Search buyers..."
              disabled={data.buyerLists && data.buyerLists.length > 0}
              allowClear
            />
          </div>
          <div className={css.filterInput}>
            <SelectBuyerList
              name="buyerLists"
              label="My buyer lists"
              control={control}
              placeholder="Select buyer list"
              mode="multiple"
              disabled={data.buyers && data.buyers.length > 0}
              allowClear
            />
          </div>
          <div className={css.filterInput}>
            <BuyerTypeSelect
              name="buyerCategories"
              control={control}
              multiple
              label="Buyer types"
              placeholder="Select buyer types"
              allowClear
            />
          </div>
        </div>

        <Divider />

        <div className={css.filterGroup}>
          <h3>Supplier</h3>

          <div className={css.filterInput}>
            <SupplierSelect name="supplierGuids" label="Supplier Guids" control={control} />
          </div>
        </div>
      </div>
    </form>
  );
}

export default SpendDataFilters;
